import {
  Flex, VStack, Button, Icon,
} from '@chakra-ui/react';

export default function Sidebar({ navItems, selected, onSelect }) {
  return (
    <Flex
      as="nav"
      width="250px"
      flexShrink={0}
      bg="gray.50"
      borderRight="1px"
      borderColor="gray.100"
      pr={4}
    >
      <VStack align="start" spacing={1} width="100%">
        {navItems.map((item) => (
          <Button
            key={item.key}
            variant="unstyled"
            colorScheme="gray"
            width="100%"
            display="flex"
            p={2}
            justifyContent="flex-start"
            align="center"
            onClick={() => onSelect(item.key)}
            size="sm"
            background={selected === item.key ? 'gray.100' : 'transparent'}
            _focus={{ boxShadow: 'none' }}
            color={selected === item.key ? 'inherit' : 'gray.500'}
            leftIcon={item.icon ? <Icon as={item.icon} boxSize={4} /> : null}
            _hover={selected === item.key ? {} : { background: 'gray.100' }}
          >
            {item.label}
          </Button>
        ))}
      </VStack>
    </Flex>
  );
}
